import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ITicketAdjuntoItem } from '../../models/ticket.model';

export interface IConfirmarAltaTicketData {
    descripcion: string;
    detalle: string;
    modulo?: string;
    menu?: string;
    usuario?: string;
    adjuntos: ITicketAdjuntoItem[];
    color_primario?: string;
}

@Component({
    selector: 'app-confirmar-alta-ticket-dialog',
    templateUrl: './confirmar-alta-ticket-dialog.component.html',
    styleUrls: ['./confirmar-alta-ticket-dialog.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule
    ]
})
export class ConfirmarAltaTicketDialogComponent {
    imagenSeleccionada: ITicketAdjuntoItem | null = null;

    constructor(
        public dialogRef: MatDialogRef<ConfirmarAltaTicketDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IConfirmarAltaTicketData
    ) {}

    esImagen(extension: string): boolean {
        const ext = (extension || '').toLowerCase();
        return ['png', 'jpg', 'jpeg', 'webp', 'gif', 'svg'].includes(ext);
    }

    obtenerIconoArchivo(extension: string): string {
        const ext = (extension || '').toLowerCase();
        if (['pdf'].includes(ext)) {
            return 'heroicons_outline:document-text';
        }
        if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext)) {
            return 'heroicons_outline:archive-box';
        }
        if (['xls', 'xlsx', 'csv'].includes(ext)) {
            return 'heroicons_outline:table-cells';
        }
        return 'heroicons_outline:paper-clip';
    }

    verAdjuntoCompleto(adjunto: ITicketAdjuntoItem): void {
        if (this.esImagen(adjunto.extension)) {
            this.imagenSeleccionada = adjunto;
        } else {
            // Para PDFs u otros archivos en Base64, abrir en una nueva pestaña del navegador
            try {
                const byteCharacters = atob(adjunto.base64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const mimeType = adjunto.extension.toLowerCase() === 'pdf' ? 'application/pdf' : 'application/octet-stream';
                const blob = new Blob([byteArray], { type: mimeType });
                const blobUrl = URL.createObjectURL(blob);
                window.open(blobUrl, '_blank', 'noopener');
            } catch (e) {
                console.error('Error al abrir el adjunto:', e);
            }
        }
    }

    cerrarVisor(): void {
        this.imagenSeleccionada = null;
    }

    cancelar(): void {
        this.dialogRef.close(false);
    }

    confirmar(): void {
        this.dialogRef.close(true);
    }
}
